module.exports = __webpack_public_path__ + "img/375.34e87ff5.jpg";